import { ip_back } from "../config";

function authHeaders() {
  const token =
    (typeof window !== "undefined" && localStorage.getItem("token")) || "";
  return token
    ? { Authorization: token, "Content-Type": "application/json" }
    : { "Content-Type": "application/json" };
}

async function parseJson(resp) {
  try {
    return await resp.json();
  } catch {
    return {};
  }
}

export async function fetchPose3dModes() {
  const resp = await fetch(`${ip_back}api/mobileAPI/pose3d/modes`, {
    headers: authHeaders(),
  });
  const json = await parseJson(resp);
  if (!resp.ok || json?.status === false) {
    throw new Error(json?.message || "Failed to list pose3d modes");
  }
  return json.data?.modes || [];
}

export async function fetchAllPose3dForTe(teId) {
  const q = new URLSearchParams({ te_id: teId, all: "1" });
  const resp = await fetch(
    `${ip_back}api/mobileAPI/pose3d/results?${q.toString()}`,
    { headers: authHeaders() }
  );
  const json = await parseJson(resp);
  if (!resp.ok || json?.status === false) {
    throw new Error(json?.message || "Failed to load pose3d results");
  }
  return json.data || {};
}

export async function comparePose3dModes({
  teId,
  modes = [
    "mono_world",
    "multi_triangulate",
    "strided_transformer",
    "lidar_iphone",
  ],
  player = "left",
} = {}) {
  const resp = await fetch(`${ip_back}api/mobileAPI/pose3d/compare`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ te_id: teId, modes, player }),
  });
  const json = await parseJson(resp);
  if (!resp.ok || json?.status === false) {
    throw new Error(json?.message || "Pose3D compare failed");
  }
  return json.data;
}

export async function fetchPose3dResult({
  jobId = null,
  teId = null,
  mode = null,
  videoUrl = null,
  sequenceOrder = null,
} = {}) {
  const q = new URLSearchParams();
  if (jobId) q.set("job_id", jobId);
  if (teId) q.set("te_id", teId);
  if (mode) q.set("mode", mode);
  if (videoUrl) q.set("video_url", String(videoUrl));
  const seq = Number(sequenceOrder);
  if (Number.isFinite(seq) && seq > 0) {
    q.set("sequence_order", String(Math.floor(seq)));
  }
  if (!jobId && !teId) throw new Error("job_id or te_id required");
  const resp = await fetch(
    `${ip_back}api/mobileAPI/pose3d/results?${q.toString()}`,
    { headers: authHeaders() }
  );
  const json = await parseJson(resp);
  if (resp.status === 404) return null;
  if (!resp.ok || json?.status === false) {
    throw new Error(json?.message || "Failed to load pose3d");
  }
  return json.data || null;
}

export async function getCameraRigCalibration({
  cameraGroupId = null,
  tableId = null,
} = {}) {
  const q = new URLSearchParams();
  if (cameraGroupId) q.set("camera_group_id", cameraGroupId);
  if (tableId) q.set("table_id", tableId);
  const resp = await fetch(
    `${ip_back}api/mobileAPI/pose3d/camera-calibration?${q.toString()}`,
    { headers: authHeaders() }
  );
  const json = await parseJson(resp);
  if (resp.status === 404) return null;
  if (!resp.ok || json?.status === false) {
    throw new Error(json?.message || "Failed to load camera rig");
  }
  return json.data || null;
}

export async function saveCameraRigCalibration(payload) {
  const resp = await fetch(
    `${ip_back}api/mobileAPI/pose3d/camera-calibration`,
    {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify(payload),
    }
  );
  const json = await parseJson(resp);
  if (!resp.ok || json?.status === false) {
    throw new Error(json?.message || "Camera calibration failed");
  }
  return json.data;
}
